import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import InputField from 'src/components/InputField'
import Switcher   from '../express-fundraiser/Switcher'

const SignUp = ({ inputProps, organizer_create, toggleSignIn, omni, children }) =>
  <div className="mb-5">
    {
      !organizer_create &&
      <Switcher omni={omni} toggleSignIn={toggleSignIn}>
        <FontAwesomeIcon icon="right-to-bracket" className="me-1" />
        {' Sign In with Email'}
      </Switcher>
    }

    <h2 className="text-center">Contact Info</h2>

    {children}

    <div className="row gx-2">
      <div className="col-sm-6">
        <InputField
          {...inputProps('first_name')}
          required
          label="First name"
          autoComplete="given-name"
        />
      </div>

      <div className="col-sm-6">
        <InputField
          {...inputProps('last_name')}
          required
          label="Last name"
          autoComplete="family-name"
        />
      </div>
    </div>

    <InputField
      {...inputProps('email')}
      required
      label="Email"
      autoComplete="username"
    />

    <hr className="mt-5 mx-edge text-body-secondary" />
  </div>

export default SignUp
